import { HttpClient } from '@angular/common/http';
import { ApplicationInsights, DistributedTracingModes, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { Observable, catchError, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';

export const initializeThirdParty = (httpClient: HttpClient): (() => Observable<AppConfig>) => {
    return () =>
        httpClient.get<AppConfig>('/assets/config/config.json').pipe(
            tap((config: AppConfig) => {
                window.globalApiEndpoint = config.globalApiEndpoint;
                window.env = config.environment;
                initializeAppInsights(config);
            }),
            catchError((error) => {
                console.error('Error during initialization:', error);
                return throwError(() => new Error(error));
            })
        );
};

const initializeAppInsights = (config: AppConfig): void => {
    if (!config.appInsightsKey) return;

    window.appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: config.appInsightsKey,
            distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
            enableAutoRouteTracking: true,
            enableCorsCorrelation: true,
            disableFetchTracking: false,
            correlationHeaderExcludedDomains: ['*.product.buildxact.com'],
            correlationHeaderDomains: ['*.buildxact.com', '*.buildxact.com.au'],
        },
    });
    window.appInsights.loadAppInsights();
    // send app version on all telemetry
    const telemetryInitializer = (envelope: ITelemetryItem) => {
        if (envelope.baseData) {
            envelope.baseData['properties'] = envelope.baseData['properties'] || {};
            envelope.baseData['properties'].appVersion = config.appVersion;
        }
        if (envelope.tags) {
            envelope.tags['ai.cloud.role'] = 'Onsite Web';
        }
    };
    window.appInsights.addTelemetryInitializer(telemetryInitializer);
    window.appInsights.trackPageView();
};

type AppConfig = {
    environment: string;
    appVersion: string;
    appInsightsKey: string;
    globalApiEndpoint: string;
};
